import { computed, Injectable, signal } from '@angular/core';
import { ACCOUNTS } from '../services/mock-data';
import type { Account } from '../models/account.model';

@Injectable({ providedIn: 'root' })
export class AccountStore {
  /** Synchronous cache seeded from mock data — swap for a service-backed store later. */
  readonly accounts = signal<Account[]>(ACCOUNTS);
  readonly selectedAccountId = signal<string>('acct-ferris');

  readonly selectedAccount = computed<Account | undefined>(() =>
    this.accounts().find((a) => a.id === this.selectedAccountId()),
  );

  selectAccount(id: string): void {
    this.selectedAccountId.set(id);
  }
}
